import styled from '@emotion/styled';

export const Content = styled.div`
@media screen {
    .container-list {
        max-width: 1000px;
        margin-top : 100px;
    }

    .rowatas {
        margin-bottom: 50px;
        justify-content: space-between;
    }

    .dropdownkum {
        left: -5%;
    }

    .show>.btn-primary.dropdown-toggle{
        color:black;
        background-color: white;
        border-color : black;
    }

    .btn-primary{
        color:black;
        background-color: white;
        border-color : black;
    }

    a{
        color : #656565 ;
        font-weight: 500;
    }
    
    a:hover{
        color: #001457;
    }
    
    .nav-link.active{
        color: #black;
        background-color: #F5F5F5;
    }
    
    .tabkum {
        font-size : 20px;
    }
}

@media screen and (max-width: 1300px) {
    .tabs-filter {
        margin-left: 2%;
        margin-right: 2%;
    }
} 
`;
